import React, {PureComponent} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {picturesSelector} from "../../selectors";
import Pictures from "./Pictures";
import trackEvent from "../../../../utils/track-event";

export class PictureBox extends PureComponent {
  static propTypes = {
    activeCategory: PropTypes.string,
    pictures: PropTypes.object,
    onRequestCloseModal: PropTypes.func
  };
  state = {
    activeCategory: this.props.activeCategory
  };
  setActiveCategory = (category) => () => {
    this.setState({
      activeCategory: category
    });
    if (category === `textures`) {
      trackEvent({
        category: `Editor`,
        action: `Texture tab click`
      });
    }
  };
  render() {
    const {activeCategory} = this.state;
    const {pictures, onRequestCloseModal} = this.props;
    return (
      <div className="picture-box">
        <div className="picture-box__nav">
          {[
            {
              name: `Мои фото`,
              type: `images`
            },
            {
              name: `Текстуры`,
              type: `textures`
            }
          ].map((category) => {
            const {type, name} = category;
            return (
              <React.Fragment key={type}>
                <div
                  className={`picture-box__category${
                    type === activeCategory
                      ? ` picture-box__category_active`
                      : ``
                  }`}
                  onClick={this.setActiveCategory(type)}
                >
                  {name}
                </div>
                {` `}
              </React.Fragment>
            );
          })}
        </div>
        <div className="picture-box__content">
          <Pictures
            type={activeCategory}
            pictures={pictures[activeCategory]}
            removability={activeCategory === `images`}
            onRequestCloseModal={onRequestCloseModal}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  pictures: picturesSelector(state)
});

export default connect(mapStateToProps)(PictureBox);
